module.exports = __webpack_public_path__ + "961bc7a21a39d4b1b3ff3a8c77e9fc70.pdf";